<template lang="html">
    <div id="orderSteps" v-if="cartOrderSelection.modalPosition != '' && user.token != null">
        <div class="rel d-flex justify-content-center align-items-start align-content-start">
            <div class="floatRectangle mt-md-5 mt-0">
                <div class="rel d-flex flex-wrap justify-content-end align-items-start align-content-start pb-4" 
                :class="pending != 0 ? (pending == 1 ? 'out' : (pending == 2 ? 'in' : '')) : ''">


                    <div class="headerModal w-100 d-flex flex-wrap justify-content-start align-items-center align-content-center position-relative px-md-5 px-3 py-md-4 py-3"> <!-- barra superior de modal -->
                        <span class="titleSelect text-start ts-11 font-3 col-md-10 col-9">
                            {{cartOrderTransition[cartOrderSelection.modalPosition].title[lang]}}
                        </span>
                        <div @click="close()" class="closeButton h-100 col-md-2 col-3 font-7 d-flex align-items-center align-content-center justify-content-center" role="button">
                            <img v :src="a10" v-svg-inline>
                        </div>
                    </div>

                    <div class="w-100 position-relative px-md-5 px-3 mt-3 pt-2 d-flex justify-content-end flex-wrap align-items-start align-content-start">
                   
                        <template v-for="(option, opidx) in cartOrderTransition[cartOrderSelection.modalPosition].options"> <!-- listado de opciones que tiene la ventana/paso en este momento -->

                            <div 
                            v-if="option.show"
                            :enabled="option.enabled"
                            class="option mb-4 w-100 d-flex ps-3 pe-1 pe-sm-4 pe-md-0" 
                            :class="option.idOption == cartOrderSelection[cartOrderSelection.modalPosition].selected ? 'selected' : (cartOrderSelection[cartOrderSelection.modalPosition].selected != '' ? 'notSelected' : '') " 
                            @click="selectOption($event, option.idOption, cartOrderSelection.modalPosition, cartOrderTransition[cartOrderSelection.modalPosition].defValue, null, true, option.allow == 6)">
                            
                                <!-- opcion de checkbox internamente tiene anidado el contenido si es seleccionado -->
                                <data class="checkBoxArea pe-none">
                                    <div class="commonPageCheckbox">
                                        <input :id="opidx" type="checkbox" :checked="option.idOption == cartOrderSelection[cartOrderSelection.modalPosition].selected">
                                        <label :for="opidx" class="me-1 ">
                                        <span class="pe-none"><img :src="option.simbol"></span></label>
                                    </div>
                                </data>

                                <div class="dataArea content d-flex" :class="cartOrderSelection.modalPosition == 'onlineMode' ? 'flex-wrap' : 'flex-nowrap'">

                                    <!-- lateral informacion de columna izquierda -->

                                    <div class="col-md-8 col-12 d-flex flex-wrap flex-column pe-3" >

                                        <div class="titleOption w-100 py-3 text-start font-5 ps-2 pe-none">
                                            <template v-if="cartOrderSelection.modalPosition == 'payForm'">
                                                <template v-if="opidx == 1"> <!-- en caso de ser la ventana tiempo de entrega, personalizar texto dependiendo del tipo de envio seleccionado-->
                                                    <template v-if="cartOrderSelection.sendType.selected == 'delivery'">
                                                        <span>{{ option.description[lang] }}&nbsp;</span>
                                                    </template>
                                                    <template v-else>
                                                        <span>{{ phrases.f36[lang] }}&nbsp;</span>  
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <span>{{ option.description[lang] }}&nbsp;</span>
                                                </template>
                                            </template>
                                            <template v-else>
                                               <span>{{ option.description[lang] }}&nbsp;</span>
                                            </template>
                                            <template v-if="cartOrderSelection.modalPosition == 'schedule'">
                                                <template v-if="opidx == 1"> <!-- en caso de ser la ventana tiempo de entrega, personalizar texto dependiendo del tipo de envio seleccionado-->
                                                    <template v-if="cartOrderSelection.sendType.selected == 'delivery'">
                                                        {{phrases.f9[lang]}}
                                                    </template>
                                                    <template v-else>
                                                        {{phrases.f10[lang]}}
                                                    </template>
                                                </template>
                                            </template>
                                        </div>

                                        
                                        
                                        <div class="listDataOption w-100 flex-fill d-flex flex-wrap font-7 text-start ps-md-4 ps-2"> <!-- contenido de la opcion checkbox descripcion -->

                                            <template v-if="cartOrderSelection.modalPosition == 'sendType'">  <!-- tipo de envio -->

                                                <!-- delivery -->

                                                <template v-if="option.idOption == 'delivery' && cartOrderSelection[cartOrderSelection.modalPosition].selected == 'delivery'">

                                                    <!-- modal esta seleccionado para de -->

                                                    <svg class="icon-select" @click="toggleSlectorDirOrSelect($event, null, true)" :class="openDirSelector ? 'opened' : ''" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="M759.2 419.8L697.4 358 512 543.4 326.6 358l-61.8 61.8L512 667z"/></svg>

                                                    <div class='dirComplete w-100 d-flex flex-wrap align-items-start align-content-start'>
                                                        <template v-for="(dir, dirName) in user.data.homes" >
                                                            <div v-if="(dirName == cartOrderSelection[cartOrderSelection.modalPosition].value || openDirSelector) && cityHasStore(dir.storeNumber)" @click="toggleSlectorDirOrSelect($event, dirName)" :class="openDirSelector ? 'mb-4' : ''" class="w-100 d-flex flex-wrap align-items-start align-content-start justify-content-start text-start">
                                                                <span v-if="this.user.dataToken.data.level == 1" class="colonyText d-flex flex-wrap flex-sm-nowrap w-100">
                                                                    <span class=" d-flex col-12 col-sm-auto">
                                                                    {{ dir.colony }}<span class="d-sm-inline d-none">&nbsp;-&nbsp;</span>
                                                                    </span>
                                                                    <span class="cpText font-1 d-flex flex-wrap">
                                                                        <span class="w-100">CP {{dir.zip}}</span>
                                                                        <span v-if="this.user.dataToken.data.level == 1" class="editButton font-7 mt-2" @click="returnToCarLater()"> {{phrases.f35[lang]}}
                                                                        </span>
                                                                    </span>
                                                                </span>
    
                                                                <span v-if="this.user.dataToken.data.level >= 2" class="colonyText w-100">{{ dir.colony }} - <span class="cpText font-1">CP {{dir.zip}}</span>
                                                                </span>
                                                                
    
                                                                <template v-if="this.user.dataToken.data.level >= 2">
                                                                    {{ dir.street }}
                                                                    <template v-if="dir.extNumber != ''">&nbsp;{{ dir.extNumber }}</template>
                                                                    <template v-if="dir.intNumber != ''">&nbsp;int:{{ dir.intNumber }}</template>
                                                                    <template v-if="dir.crossing != ''">&nbsp;{{ dir.crossing }}</template>
                                                                </template>

                                                                <span class='dirComplete w-100' v-if="this.user.dataToken.data.level >= 2">
                                                                    <template v-if="dir.refer != ''">{{ dir.refer }}</template>
                                                                    <span class="editButton font-7" @click="returnToCarLater(dirName)">&nbsp;&nbsp;{{phrases.f1[lang]}}</span>
                                                                </span>
                                                            </div>

                                                            
                                                        </template>
                                                    </div>

                                                    <template v-if="option.allow === 1 && !openDirSelector">  <!-- allow 1 usuario login -->
                                                        <template v-if="user.data.deliveryDir == '' || user.data.deliveryDir == undefined" > <!--  sin direccion -->
                                                            <span class="font-5 mt-3">{{phrases.f22[lang]}}</span>
                                                            <span class="editButton font-5" @click="returnToCarLater()">{{phrases.f18[lang]}}</span> 
                                                        </template>
                                                        <template v-else>  <!-- direccion sin cobertura de delivery  -->
                                                            <span class="font-5 my-3
                                                            " @click="returnToCarLater()">{{phrases.f20[lang]}}</span>
                                                            <span class="editButton font-5" @click="returnToCarLater(dirName)">{{phrases.f21[lang]}}</span>
                                                        </template>
                                                    </template>

                                                    <template v-else-if="option.allow === 3 && !openDirSelector">  <!-- direccion no corresponde con ciudad  -->
                       
                                                        <span class="font-5 mt-3">{{phrases.f32[lang]}}</span>
                                                        <span class="editButton font-5" @click="returnToCarLater()">{{phrases.f18[lang]}}</span> 
                                                    </template>

                                                    <template v-else-if="option.allow === 4 && !openDirSelector"> <!--  direccion correcta pero sucursal cerrada  -->
                                                        
                                                        <span class="font-5 mt-3">{{phrases.f26[lang]}}</span>
                                                    </template>

                                                    <template v-else-if="option.allow === 5 && !openDirSelector"> <!--  direccion correcta pero sucursal con error -->
                                                        
                                                        <span class="font-5 mt-3">{{phrases.f27[lang]}}</span>
                                                    </template> 
                                                    
                                                </template>

                                                <!-- pickup -->

                                                <template v-else-if="option.idOption == 'pickup' && cartOrderSelection[cartOrderSelection.modalPosition].selected == 'pickup'">
                                                    <span class="font-5 mb-3">{{phrases.f25[lang]}}</span>
                                                    <select-custom 
                                                    @click="stop($event)" 
                                                    :keyShow="'name'" 
                                                    :list="storesAvailables" 
                                                    :placeholder="phrases.f11[lang]"
                                                    @change="(selectedValue, e) => selectOption(e, option.idOption, cartOrderSelection.modalPosition, selectedValue)" :value="cartOrderSelection[cartOrderSelection.modalPosition].value">
                                                    </select-custom>
                                                            
                                                </template>

                                            </template>

                                            <template v-if="cartOrderSelection.modalPosition == 'schedule'">  <!-- tiempo de envio -->

                                                <!-- now -->

                                                <template v-if="option.idOption == 'now'">
                                                    
                                                    <span class="descriptionText font-2">
                                                        {{phrases.f6[lang]}}
                                                    </span>

                                                </template>

                                                <!-- await / programar -->

                                                <template v-else-if="option.idOption == 'await'">

                                                    <span class="descriptionText font-2 w-100">
                                                        {{phrases.f7[lang]}}
                                                    </span>

                                                    <div class="w-100 d-flex flex-wrap flex-md-nowrap mt-4" v-if="cartOrderSelection[cartOrderSelection.modalPosition].selected == 'await'">
                                                        <div class="col-12 col-md-7 d-flex me-2">
                                                            <select-custom 
                                                            @click="stop($event)" 
                                                            :list="getPickupDates()" 
                                                            @change="(selectedValue, e) => selectOption(e, option.idOption, cartOrderSelection.modalPosition, selectedValue, 'date')" 
                                                            :keyShow="'day'" 
                                                            :placeholder="phrases.f12[lang]"
                                                            :value="cartOrderSelection[cartOrderSelection.modalPosition].value.date" 
                                                            :type="'key'">
                                                            </select-custom>
                                                        </div>
                                                        <div v-if="Object.keys(getAvailableHours(cartOrderSelection[cartOrderSelection.modalPosition].value.date)).length > 0" class="col-12 col-md-5 mt-2 mt-md-0 mb-2 mb-md-0 d-flex" :class="cartOrderSelection[cartOrderSelection.modalPosition].value.date == '' ? 'pe-none' : ''">
                                                            <select-custom 
                                                            @click="stop($event)" 
                                                            :list="getAvailableHours(cartOrderSelection[cartOrderSelection.modalPosition].value.date)" 
                                                            @change="(selectedValue, e) => selectOption(e, option.idOption, cartOrderSelection.modalPosition, selectedValue, 'hour')" 
                                                            :keyShow="''" 
                                                            :placeholder="phrases.f13[lang]"
                                                            :value="cartOrderSelection[cartOrderSelection.modalPosition].value.hour" 
                                                            :type="'key'">
                                                            </select-custom>
                                                        </div>
                                                    </div>

                                                </template>

                                            </template>

                                            <template v-if="cartOrderSelection.modalPosition == 'cashMode'">  <!-- forma de pago / cambio -->

                                                    <span class="subtitled font-7 w-100">
                                                        {{phrases.f31[lang]}}
                                                    </span>

                                                    <input @input="numericsData($event, 'event')" @click="stop($event)" autocomplete="off" autocorrect="off" @change="($event)=> selectOption($event, option.idOption, cartOrderSelection.modalPosition, $event.target.value)" :placeholder="phrases.f17[lang]" :value="cartOrderSelection[cartOrderSelection.modalPosition].value" autocapitalize="off" spellcheck="false" class="commonMinInput w-100 px-3 font-7 mt-3 mb-3" maxlength="4" type="text">

                                            </template>

                                        </div>
                                    </div>

                                    <!-- lateral informacion de columna derecha -->

                                    <div class="timeIndicator col-4 d-none d-md-flex flex-wrap align-content-start align-items-start pt-0 align-items-md-start align-content-md-start">

                                        <template v-if="cartOrderSelection.modalPosition == 'sendType'"> <!-- tipo de envio -->
                                            <div class="timeLabel font-7 w-100 pt-md-4 pt-0 "> <!-- texto superior -->
                                                <template v-if="option.idOption == 'delivery' && option.allow === 2"> <!-- delivery y direccion en correctas condiciones -->
                                                    40”
                                                </template>
                                                <template v-else-if="option.idOption == 'delivery' && (option.allow == 1 ||  option.allow == 3 || option.allow == 4 || option.allow == 5)"> <!-- delivery y sin direccion -->
                                                    <img :src="a48" class="mb-2">
                                                </template>
                                                <template v-else-if="option.idOption == 'pickup'"> <!-- pasar a tienda -->
                                                    15”
                                                </template>
                                            </div>
                                            <div class="subTimeLabel font-1 w-100" v-if="option.enabled"> <!-- texto inferior -->
                                                <template v-if="option.idOption == 'delivery' && (option.allow == 1 ||  option.allow == 3 ||  option.allow == 5 ||  option.allow == 4)"> <!-- delivery y sin direccion -->
                                                    <template v-if="Object.keys(user.data.homes).length <= 0">{{ phrases.f23[lang] }}</template> 
                                                    <template v-else>{{ phrases.f24[lang] }}</template>
                                                </template>
                                                <template v-else> <!-- todo correcto -->
                                                    {{ phrases.f4[lang] }}
                                                </template>
                                            </div>
                                        </template>

                                        <template v-if="cartOrderSelection.modalPosition == 'schedule'"> <!-- tiempo de envio -->
                                            <div class="timeLabel font-7 w-100 pt-md-4 pt-0 ">
                                                <template v-if="option.idOption == 'now'"> <!-- ahora -->
                                                   <template v-if="cartOrderSelection.sendType.selected == 'pickup' "> 15” </template>
                                                   <template v-else> 40” </template>
                                                </template>
                                                <template v-if="option.idOption == 'await'"> <!-- ahora -->
                                                    <img :src="a49" class="mb-2 iconOption">
                                                 </template>
                                            </div>
                                            <div class="subTimeLabel font-1 w-100" v-if="option.idOption == 'now'">
                                                <template v-if="cartOrderSelection.sendType.selected == 'pickup' "> {{ phrases.f4[lang] }} </template>
                                                <template v-else> {{ phrases.f5[lang] }} </template>
                                            </div>
                                            <div class="subTimeLabel font-1 w-100" v-if="option.idOption == 'await'">
                                                {{ phrases.f33[lang] }}
                                            </div>
                                        </template>

                                        <template v-if="cartOrderSelection.modalPosition == 'payForm'"> <!-- forma de pago -->
                                            <div class="iconSpace font-7 w-100 d-flex justify-content-end pe-none">
                                                <img v-svg-inline class="posIcon" :src="option.icon"  :key="opidx">
                                            </div>
                                        </template>
                                        

                                    </div>

                                    <!-- en casos especiales para centrar contenido -->

                                    <template v-if="cartOrderSelection.modalPosition == 'onlineMode'">  <!-- forma de pago / cambio -->

                                        <template v-for="(carItemsInCat, carCat) in articles">

                                            <div class="categoryArticles w-100 d-flex flex-wrap text-start mb-md-0 mb-3 pe-4 pe-xl-5">
                
                                                <div class="fw-bold font-8 w-100 py-3 text-start titleArticles">{{ phrases.f37[lang] }}:</div>
                
                                                <div class="categoryItems w-100 d-flex flex-wrap text-start justify-content-center pe-2">
                
                                                    <template v-for="(carItem, cidx) in carItemsInCat">
                
                                                        <div class="col-12 d-flex align-items-stretch align-content-stretch">
                                                            <div class="col-7 d-flex flex-wrap align-items-start align-content-start articleName">
                                                                {{carItem.name}}
                                                            </div>
                                                            <div class="col-5 d-flex flex-nowrap justify-content-center align-items-start align-items-start">
                                                                <div class="col-3 col-xl-7 articleQuantity text-end font-7">
                                                                    {{carItem.quantity}} <span class="d-none d-md-inline">u.</span>
                                                                </div>
                                                                <div class="col-9 col-xl-5 articlePrice text-end font-7">
                                                                    {{$filters.cash4(Number(carItem.price) * Number(carItem.quantity))}}
                                                                </div>
                                                            </div>
                                                        </div>
                
                                                    </template>
                
                                                </div>

                                                <div class="divisor mt-3"></div>

                                                <template v-if="prices.length == 2">
                                                    <template v-if="promos.length > 0">
                                                        <div class="font-8 w-100 pt-3 text-start titleArticles2 d-flex flex-nowrap pe-2">Subtotal:&nbsp;<span class="fw-bold w-100 text-end">$ {{$filters.cash2(Number(prices[0]))}}</span></div>
                                                        <div class="w-100 d-flex flex-wrap promos pe-2 mb-3 mt-2">
                                                            <div v-for="promo in promos" class="w-100 text-end promo font-7">{{promo.name}}</div>
                                                        </div>
                                                        <div class="divisor"></div>
                                                    </template>
                                                    <div class="font-8 w-100 pb-3 text-start titleArticles d-flex flex-nowrap pe-2 mt-3">Total:&nbsp;<span class="fw-bold w-100 text-end">$ {{$filters.cash2(Number(prices[1]))}}</span></div>
                                                    <div class="w-100 my-4 d-flex justify-content-center align-items-center align-content-center">
                                                        <PayPalButton :amount="prices[1].toFixed(2)" @payCompleted="sendOrder"/>
                                                    </div> 
                                                </template>
                    
                                            </div>
                
                                        </template>

                                    </template>

                                </div>

                            </div>

                        </template> 


                        <div class="commonPageButton buttonNext pushable active font-9 px-md-4 px-5 py-3 py-md-2 me-md-4 me-0 mt-4" @click="nextStep()" v-if="pending == 0 && validateNextness()"> <!-- valida si es posible continuar en el wizard (boton de continuar al siguiente paso) -->

                            <template v-if="cartOrderSelection.modalPosition == 'payForm' && cartOrderSelection[cartOrderSelection.modalPosition].selected == 'card' || cartOrderSelection.modalPosition == 'cashMode' || cartOrderSelection.modalPosition == 'onlineMode'"><span class="placeOrder">{{phrases.f3[lang]}}</span></template>

                            <template v-else>{{phrases.f2[lang]}}</template>

                        </div>


                        <div class="commonPageButton buttonNext pushable active font-9 px-md-4 px-4 py-2 py-md-2 me-md-4 me-0 mt-4" @click="returnToCarLater()" v-if="cartOrderSelection.modalPosition == 'sendType' && cartOrderSelection[cartOrderSelection.modalPosition].selected == 'delivery' && ((this.cartOrderTransition.sendType.options[0].allow === 1 && Object.keys(user.data.homes).length <= 0) || this.cartOrderTransition.sendType.options[0].allow === 3)">
                            {{phrases.f19[lang]}}
                        </div>

                        <template v-if="cartOrderSelection.modalPosition == 'storeClosed'">  <!-- mensaje de tienda cerrada -->
                            <div class="option mb-4 w-100 d-flex ps-3 pe-3 pe-md-0" >
                                <div class="w-100 content d-flex justify-content-center borderedBottom">
                                    <div class="col-md-10 col-12 d-flex flex-wrap flex-column pe-3">
                                        <div class="titleOptionError w-100 py-3 text-start font-8 fw-bold px-0">
                                            {{phrases.f29[lang]}}
                                        </div>
                                        <div class="listDataOption w-100 flex-fill d-flex flex-wrap font-7 text-start ps-2 pe-0 mb-3">
                                            <span class="descriptionText font-2">
                                                {{phrases.f26[lang]}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="commonPageButton buttonNext pushable active font-9 px-5 py-3 py-md-2 me-md-4 me-0 mt-4" @click="nextStep()">
                                {{phrases.f2[lang]}}
                            </div>
                        </template>

                        <template v-if="cartOrderSelection.modalPosition == 'storeError'">  <!-- mensaje de tienda offline -->
                            <div class="option mb-4 w-100 d-flex ps-3 pe-3 pe-md-0" >
                                <div class="w-100 content d-flex justify-content-center borderedBottom">
                                    <div class="col-md-10 col-12 d-flex flex-wrap flex-column pe-3">
                                        <div class="titleOptionError fw-bold w-100 py-3 text-start font-12 px-0">
                                            {{phrases.f30[lang]}}
                                        </div>
                                        <div class="listDataOption w-100 flex-fill d-flex flex-wrap font-7 text-start ps-2 pe-0">
                                            <span class="descriptionText font-2">
                                                {{phrases.f27[lang]}}
                                            </span>
                                        </div>
                                        <div class="callcenterText w-100 py-3 text-start font-9 ps-2 pe-0">
                                            800 BOSTONS - 800 267-86-67
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="commonPageButton buttonNext pushable active font-9 px-5 py-3 py-md-2 me-md-4 me-0 mt-4" @click="nextStep()">
                                {{phrases.f28[lang]}}
                            </div>
                        </template>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>

import PayPalButton from '@/components/responsive/structures/fillStructures/paypalBtn.vue';
import selectCustom from "@/components/responsive/structures/fillStructures/selectCustom.vue"

export default {    
    name:"citySelector",
    emits:['close', 'event'],
    components:{
        selectCustom,
        PayPalButton
    },
    props:{
        lang:{
            default:"es",
            type: String
        },
        user:{
            type:Object,
            default:{}
        },
        cityMenu:{
            default:{},
            type: Object
        },
        cities:{
            default:[],
            type: Array
        },
        socket:{
            default:{},
            type: Object
        },
        con:{
            default:{},
            type: Object
        },
        transfer:{
            type:Object,
            default:{}
        },
        cartOrderSelection:{
            default:{},
            type: Object
        },
        listStoreStatus:{
            default:{},
            type: Object
        },
        articles:{
            default:{},
            type: Object
        },
        promos:{
            default:[],
            type: Array
        },
        prices:{
            default:[],
            type: Array
        },
        dirSelected:{
            default:"",
            type: String
        }
    },
    watch:{
        dirSelected(){
            this.cartOrderTransition.sendType.options[0].allow = this.allowDelivery();
            this.cartOrderTransition.schedule.options[0].enabled = this.isOpenUserStore();
            this.cartOrderTransition.schedule.options[0].show = this.isOpenUserStore();
            this.cartOrderTransition.payForm.options[2].enabled = this.allowOnlineMode();
            this.cartOrderTransition.payForm.options[2].show = this.allowOnlineMode();
        },
        pending(){ // actualizar objetos de control
            this.cartOrderTransition.sendType.options[0].allow = this.allowDelivery();
            this.cartOrderTransition.schedule.options[0].enabled = this.isOpenUserStore();
            this.cartOrderTransition.schedule.options[0].show = this.isOpenUserStore();
            this.cartOrderTransition.payForm.options[2].enabled = this.allowOnlineMode();
            this.cartOrderTransition.payForm.options[2].show = this.allowOnlineMode();
        },
        listStoreStatus(){ // cambio de status de las tiendas
            this.listOnline();
            this.cartOrderTransition.sendType.options[0].allow = this.allowDelivery();
            this.cartOrderTransition.schedule.options[0].enabled = this.isOpenUserStore();
            this.cartOrderTransition.schedule.options[0].show = this.isOpenUserStore();
            this.cartOrderTransition.payForm.options[2].enabled = this.allowOnlineMode();
            this.cartOrderTransition.payForm.options[2].show = this.allowOnlineMode();
        },
        cityMenu(){ // cambio de ciudad/sistema despues de montado (ej. maybeAskColony restaurando la sucursal elegida): recalcular tiendas y disponibilidad
            this.listOnline();
            this.cartOrderTransition.sendType.options[0].allow = this.allowDelivery();
            this.applyScheduleRules();
        },
        'cartOrderSelection.sendType.value'(){ //cambio de sucursal destino (ej. pickup): revalidar si se puede programar
            this.applyScheduleRules();
        },
        'cartOrderSelection.sendType.selected'(){
            this.applyScheduleRules();
        },
        user(){ //cambio del objeto usuario
            this.cartOrderTransition.sendType.options[0].allow = this.allowDelivery(); //actualiza la disponibilidad de delivery
            this.cartOrderTransition.schedule.options[0].enabled = this.isOpenUserStore();
            this.cartOrderTransition.schedule.options[0].show = this.isOpenUserStore();
            this.cartOrderTransition.payForm.options[2].enabled = this.allowOnlineMode();
            this.cartOrderTransition.payForm.options[2].show = this.allowOnlineMode();
        },
        userDirectionSelected(){
            this.cartOrderTransition.sendType.options[0].allow = this.allowDelivery();
        }
    },
    beforeMount(){
        this.listOnline();
    },
    mounted(){
        this.cartOrderTransition.sendType.options[0].allow = this.allowDelivery();
        this.cartOrderTransition.schedule.options[0].enabled = this.isOpenUserStore();
        this.cartOrderTransition.schedule.options[0].show = this.isOpenUserStore();
        this.cartOrderTransition.payForm.options[2].enabled = this.allowOnlineMode();
        this.cartOrderTransition.payForm.options[2].show = this.allowOnlineMode();
        this.applyScheduleRules();
    },
    methods:{

        toggleSlectorDirOrSelect(e, dirname, toggle=false){
            e.stopPropagation()
            if(toggle){
                this.openDirSelector = !this.openDirSelector;
                return false
            }
            
            if(!this.openDirSelector){
                this.openDirSelector = true;
            }else{
                this.$emit('event', 'changeDeliveryDir', null, dirname, null); 
                this.openDirSelector = false;
            }
        },

        sendOrder(id){
            this.$emit('event', 'changeModal', 'finish', '', '', id)
        },

        cityHasStore(storeNumber){ //la ciudad puede ser de una sola tienda (storeNumber) o multi-tienda (mapa stores)
            if(this.cityMenu == null){ return false; }
            if(this.cityMenu.storeNumber == storeNumber){ return true; }
            return this.cityMenu.stores && Object.prototype.hasOwnProperty.call(this.cityMenu.stores, storeNumber);
        },

        isOtherSystemStore(storeNumber){ //la tienda pertenece a otra entrada de la ciudad (otro sistema/menu)
            if(this.cityMenu == null || !Object.prototype.hasOwnProperty.call(this.pickupStoreCity, storeNumber)){ return false; }
            return this.pickupStoreCity[storeNumber].storeNumber != this.cityMenu.storeNumber;
        },

        storeAllowsDelivery(storeNumber){ //flag de reparto de una tienda puntual (retrocompatible: sin el campo 'delivery' => permitido)
            if(this.cityMenu == null || !this.cityMenu.stores){ return true; }
            if(!Object.prototype.hasOwnProperty.call(this.cityMenu.stores, storeNumber)){ return true; }
            let store = this.cityMenu.stores[storeNumber];
            return !Object.prototype.hasOwnProperty.call(store, 'delivery') || store.delivery != 0;
        },

        storeAllowsTakeout(storeNumber){ //flag de recoger en sucursal de una tienda puntual (retrocompatible)
            if(this.cityMenu == null || !this.cityMenu.stores){ return true; }
            if(!Object.prototype.hasOwnProperty.call(this.cityMenu.stores, storeNumber)){ return true; }
            let store = this.cityMenu.stores[storeNumber];
            return !Object.prototype.hasOwnProperty.call(store, 'takeout') || store.takeout != 0;
        },

        storeIsSimphony(storeNumber){ //tiendas con POS Simphony (6029/6030): la inyeccion del pedido es inmediata
            if(this.cityMenu == null){ return false; }
            let pos = this.cityMenu.systemPOS || '';
            if(this.cityMenu.stores && Object.prototype.hasOwnProperty.call(this.cityMenu.stores, storeNumber)){
                pos = this.cityMenu.stores[storeNumber].systemPOS || pos;
            }
            return String(pos).toLowerCase() == 'simphony';
        },

        allowSchedule(){ //la opcion 'Programar' no aplica en sucursales Simphony: solo preparar ahora mismo
            let target = this.cartOrderSelection.sendType && this.cartOrderSelection.sendType.selected == 'pickup' && this.cartOrderSelection.sendType.value !== ''
                ? this.cartOrderSelection.sendType.value
                : (this.cityMenu != null ? this.cityMenu.storeNumber : null);
            return !this.storeIsSimphony(target);
        },

        applyScheduleRules(){ //muestra/oculta 'Programar' segun la sucursal destino y limpia la seleccion si quedo invalida
            let allow = this.allowSchedule();
            this.cartOrderTransition.schedule.options[1].show = allow;
            this.cartOrderTransition.schedule.options[1].enabled = allow;
            if(!allow && this.cartOrderSelection.schedule.selected == 'await'){
                this.cartOrderSelection.schedule.selected = '';
                this.cartOrderSelection.schedule.value = '';
            }
        },

        cityAllowsDelivery(){ //true si al menos una sucursal de la ciudad admite reparto (ej. Galerías QRO solo take out => false)
            if(this.cityMenu == null || !this.cityMenu.stores || Object.keys(this.cityMenu.stores).length <= 0){ return true; }
            for(let i in this.cityMenu.stores){
                if(this.storeAllowsDelivery(i)){ return true; }
            }
            return false;
        },

        cityGroupEntries(){ //todas las entradas de ciudad que comparten friendlyName con la actual (un sistema/menu por entrada, ej. Merida Positouch y Prime)
            if(this.cityMenu == null){ return []; }
            const group = (this.cities || []).filter(c => c.friendlyName == this.cityMenu.friendlyName);
            return group.length > 0 ? group : [this.cityMenu];
        },

        listOnline(){ //itera las tiendas de todos los sistemas de la ciudad con la consulta de status para verificar su accesibilidad
            this.storesAvailables = {};
            this.pickupStoreCity = {};
            const statusList = this.listStoreStatus || {}; //si statusAll fallo, seguir con lista vacia en vez de tronar
            for(const entry of this.cityGroupEntries()){
                for(let i in entry.stores){
                    let store = entry.stores[i];
                    if(Object.prototype.hasOwnProperty.call(store, 'takeout') && store.takeout == 0){ continue; } //excluir del pickup las sucursales que no ofrecen recoger en tienda
                    if(statusList.hasOwnProperty(i)){
                        if(statusList[i].status == 'open' || statusList[i].status == 'close'){
                            this.storesAvailables[i] = store;
                            this.pickupStoreCity[i] = entry; //sistema al que pertenece la tienda (para avisar del cambio de menu)
                        }
                    }
                }
            }
            if(Object.keys(this.storesAvailables).length <= 0){
                this.cartOrderTransition.sendType.options[1].enabled = false; // deshabilitar la opcion de pickup si no hay tiendas online
            }else{
                this.cartOrderTransition.sendType.options[1].enabled = true;
            }
            this.cartOrderTransition.sendType.options[0].show = this.cityAllowsDelivery(); // ocultar 'Envío a domicilio' si ninguna sucursal de la ciudad hace reparto
        },

        numericsData(e, type='direct'){
            if(!e || e == null){
                return ''
            }
            switch(type) {
                case 'direct':
                    // Limpiar el valor y convertirlo a un número entero válido
                    const cleanedValue = e.replace(/[^0-9]/g, '');
                    return cleanedValue === '' ? 0 : parseInt(cleanedValue, 10);
                case 'event':
                    if(isNaN(e.target.value)){
                        e.target.value = 0;
                    }
                    if (e.target && e.target.value !== undefined) {
                        let value = e.target.value;
                        // Limpiar el valor y convertirlo a un número entero válido
                        value = value === '' ? 0 : parseInt(e.target.value.replace(/[^0-9]/g, ''), 10);
                        e.target.value = value;
                    }
                    break;
            }
        },

        validateNextness(){ // valida lo necesario para aparecer el boton de siguiente paso en modales
            switch(this.cartOrderSelection.modalPosition){
                case 'sendType':
                    switch(this.cartOrderSelection.sendType.selected){
                        case 'delivery':
                            return this.cartOrderSelection.sendType.value != '' && this.cartOrderSelection.sendType.value != null && (this.cartOrderTransition.sendType.options[0].allow === 2 || this.cartOrderTransition.sendType.options[0].allow === 4)
                            break;
                        case 'pickup':
                            return this.cartOrderSelection.sendType.value != '' && this.cartOrderSelection.sendType.value != null
                            break;
                        default:
                            return false
                            break;
                    }
                    break;
                case 'schedule':
                    switch(this.cartOrderSelection.schedule.selected){
                        case 'now':
                            return this.cartOrderSelection.schedule.value != '' && this.cartOrderSelection.schedule.value != null
                            break;
                        case 'await':
                            if(typeof this.cartOrderSelection.schedule.value === 'object'){
                                if(this.cartOrderSelection.schedule.value.date == ''
                                || this.cartOrderSelection.schedule.value.date == null 
                                || this.cartOrderSelection.schedule.value.hour == ''
                                || this.cartOrderSelection.schedule.value.hour == null){
                                    return false
                                }
                                return true
                            }
                            return this.cartOrderSelection.schedule.value != '' && this.cartOrderSelection.schedule.value != null
                            break;
                        default:
                            return false
                            break;
                    }
                    break;
                case 'payForm':
                    return this.cartOrderSelection.payForm.selected != '' && this.cartOrderSelection.payForm.selected != null
                    break;
                case 'cashMode':
                    return true
                    break;
                default:
                    return false
                    break;
            }
        },

        allowOnlineMode(){
            if(this.user.token != null && this.cartOrderSelection.schedule.selected != 'await'){ 
                if(this.user.data.hasOwnProperty('paymentOnline')){
                    return this.user.data.paymentOnline
                }
            }
            return false
        },

        trySelectDefaultDir(){
            if(this.user.token != null){
                if(this.user.data.deliveryDir != '' && this.user.data.deliveryDir != undefined){
                    if(this.user.data.homes.hasOwnProperty(this.user.data.deliveryDir)){
                        if(this.userDirectionSelected == null){
                            this.userDirectionSelected = this.user.data.deliveryDir;
                        }else{
                            return this.userDirectionSelected;
                        }
                    }
                }
            }
            return null
        },

        allowDelivery(){ // valida si es posible la opcion delivery en la direccion seleccionada
            let allowed = 0; // sin token de usuario, denegar acceso

            if(this.user.token != null){

                allowed = 1 // con token de usuario pero sin direccion
   
                if(this.dirSelected != '' && this.dirSelected != null){ //usuario tiene determinado su direccion de envio o es la default

                    let userDirection = this.user.data.homes[this.dirSelected];

                    if(userDirection.hasOwnProperty('delivery')){

                        if(userDirection.delivery != false){ // tiene servicio

                            if(!this.cityHasStore(userDirection.storeNumber)){
                                allowed = 3 //direccion no corresponde a ciudad seleccionada de la pagina
                            }else if(!this.storeAllowsDelivery(userDirection.storeNumber)){
                                allowed = 3 //la sucursal de esta direccion no ofrece reparto (solo take out)
                            }else{
                                if(this.listStoreStatus){
                                    if(this.listStoreStatus.hasOwnProperty(userDirection.storeNumber)){
                                        switch(this.listStoreStatus[userDirection.storeNumber].status){
                                            case 'open':
                                                allowed = 2
                                                break;
                                            case 'close':
                                                allowed = 4
                                                break;
                                            case 'offline':
                                            default:
                                                allowed = 5
                                                break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    
                }
       
            }
            return allowed
        },

        getAvailableHours(dateString=''){

            let storeID = 0;
            switch(this.cartOrderSelection.sendType.selected){
                case 'delivery': //nombre de direccion del usuario en value
                    storeID = this.user.data.homes.hasOwnProperty(this.cartOrderSelection.sendType.value) ? this.user.data.homes[this.cartOrderSelection.sendType.value].storeNumber : 0;
                    break;
                case 'pickup': //id de la tienda en value
                    storeID = this.cartOrderSelection.sendType.value;
                    break;
            }
            if(this.user.token != null){
                for(let i in this.cityMenu.stores){
                    if(i == storeID){
                        return this.getAvailableHoursList(dateString, Number(this.cityMenu.stores[i].calendar.openPickup), Number(this.cityMenu.stores[i].calendar.closePickup))
                    }
                }
            }
            return {}
        },

        getAvailableHoursList(dateString='', open=13, close=19) {
            if(dateString == '' || dateString == null){
                return {}
            }
            const [day, month, year] = dateString.split('-').map(Number);
            const selectedDate = new Date(year, month - 1, day); 
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0); 
            const allowedHours = Array.from({ length: close - open + 1 }, (_, index) => open + index);

            const selectedDateTime = selectedDate.getTime();
            const currentDateTime = currentDate.getTime();

            // Objeto para almacenar las horas disponibles
            const availableHoursObj = {};

            // Si la fecha es pasada (antes de hoy), retornar un objeto vacío
            if (selectedDateTime < currentDateTime) {
                return {};
            }

            // Si la fecha es hoy, retornar las horas restantes del día que no han pasado todavía
            if (selectedDateTime === currentDateTime) {
                const currentHour = new Date().getHours();
                const minutesUntilNextHour = 60 - new Date().getMinutes(); // minutos hasta la próxima hora
                const nextHour = currentHour + 1;
                
                // Obtener las horas disponibles a partir de la próxima hora con al menos 40 minutos disponibles
                allowedHours.forEach(hour => {
                if (hour > nextHour || (hour === nextHour && minutesUntilNextHour >= 40)) {
                    const formattedHour = hour < 10 ? `0${hour}:00` : `${hour}:00`;
                    availableHoursObj[formattedHour] = {};
                }
                });
                
                return availableHoursObj;
            }

            // Si la fecha es futura pero está dentro del rango permitido, retornar todas las horas permitidas
            if (selectedDateTime > currentDateTime) {
                allowedHours.forEach(hour => {
                const formattedHour = hour < 10 ? `0${hour}:00` : `${hour}:00`;
                availableHoursObj[formattedHour] = {};
                });
                return availableHoursObj;
            }

            // Si la fecha es futura pero está fuera del rango permitido, retornar un objeto vacío
            return {};
        },

        postDates(open=13, close=19, todayEnabled=true, tomorrowEnable=true, dAfterTomorrowEnabled=true){
            const dates = {};
            const today = new Date();

            // Obtener la hora actual y verificar si ya son la hora final de pickup o mas tarde
            // y si faltan menos de 40 minutos para las la hora de cierre de pickup hrs
            const currentHour = today.getHours();
            const currentMinute = today.getMinutes();
            const closedStore = currentHour >= close;
            const nearToCloseStore = (currentHour === (close-1) && currentMinute >= 20); //menos de 20mins

            for (let i = 0; i < 3; i++) {
               
                if (i === 0 && (nearToCloseStore || closedStore || !todayEnabled)) {
                    continue; // ya cerro o esta apunto de cerrar en i==0 (hoy)
                }
                if (i === 1 && (!tomorrowEnable)) {
                    continue; // ya cerro o esta apunto de cerrar en i==0 (hoy)
                }
                if (i === 2 && (!dAfterTomorrowEnabled)) {
                    continue; // ya cerro o esta apunto de cerrar en i==0 (hoy)
                }
                const date = new Date(today);
                date.setDate(date.getDate() + i);
                const dd = String(date.getDate()).padStart(2, '0');
                const mm = String(date.getMonth() + 1).padStart(2, '0');
                const yyyy = date.getFullYear();
                const formattedDate = `${dd}-${mm}-${yyyy}`;
                const day = (i === 0) ? this.phrases.f14[this.lang] : (i === 1) ? this.phrases.f15[this.lang] : this.phrases.f16[this.lang];
                const dateKey = `${yyyy}-${mm}-${dd}`;
                dates[formattedDate] = { day: day, dateKey: dateKey };
            }
            return dates;
        },

        getPickupDates() {
            let storeID = 0;
            let today = false;
            let tomorrow = false;
            let afterTomorrow = false;

            switch(this.cartOrderSelection.sendType.selected){
                case 'delivery': //nombre de direccion del usuario en value
                    storeID = this.user.data.homes.hasOwnProperty(this.cartOrderSelection.sendType.value) ? this.user.data.homes[this.cartOrderSelection.sendType.value].storeNumber : 0;
                    break;
                case 'pickup': //id de la tienda en value
                    storeID = this.cartOrderSelection.sendType.value;
                    break;
            }

            if(this.listStoreStatus){ // revisa si esta abierta la tienda para permitir el 'hoy'
                if(this.listStoreStatus.hasOwnProperty(storeID)){
                    if(this.listStoreStatus[storeID].today == true){
                        today = true
                    }
                    if(this.listStoreStatus[storeID].tomorrow == true){
                        tomorrow = true
                    }
                    if(this.listStoreStatus[storeID].dayAfterTomorrow == true){
                        afterTomorrow = true
                    }
                }
            }

            if(this.user.token != null){
                for(let i in this.cityMenu.stores){
                    if(i == storeID){
                        return this.postDates(Number(this.cityMenu.stores[i].calendar.openPickup), Number(this.cityMenu.stores[i].calendar.closePickup), today, tomorrow, afterTomorrow)
                    }
                }
            }
            return {}
        },

        stop(e){
            e.stopImmediatePropagation();
            e.stopPropagation();
        },

        nextStep(){
            this.pending = 1;
            setTimeout(()=>{
                switch(this.cartOrderSelection.modalPosition){
                    case 'sendType':
                        this.$emit('event', 'changeModal', 'schedule')
                        break;
                    case 'schedule':
                        this.$emit('event', 'changeModal', 'payForm')
                        break;
                    case 'payForm':
                        switch(this.cartOrderSelection.payForm.selected){
                            case 'cash':
                                this.$emit('event', 'changeModal', 'cashMode')
                                break;
                            case 'card':
                                this.$emit('event', 'changeModal', 'finish')
                                break;
                            case 'paypal':
                                this.$emit('event', 'changeModal', 'onlineMode')
                                this.$emit('event', 'selectOption', 'default', 'onlineMode', true);
                                break;
                            default:
                                break;
                        }
                        break;
                    case 'cashMode':
                        this.$emit('event', 'changeModal', 'finish')
                        break;
                    case 'storeClosed':
                        this.$emit('event', 'changeModal', 'schedule')
                        break;
                    case 'storeError':
                        this.$emit('event', 'resetModal')
                        break;
                    case 'storeOffline':
                        this.$emit('event', 'resetModal')
                        break;
                }
            }, 100);
            setTimeout(()=>{
                this.pending = 2;
                setTimeout(()=>{
                    this.pending = 0;
                }, 300)
            }, 100)
        },

        close(){
            this.$emit('close')
        },

        selectOption(e=null, id, optionModal, value='', key='', fullOption=false, block=false){


            this.openDirSelector = false;
            let checkSchedule = false;

            if (event !== null) {
                event.stopPropagation(); // Solo llama stopPropagation si event no es null
            }

            if(block){
                return false;
            }

            if(this.cartOrderSelection[this.cartOrderSelection.modalPosition].selected == id && this.cartOrderSelection.modalPosition == optionModal && (this.cartOrderSelection[this.cartOrderSelection.modalPosition].value == value || value == null || value == '')){
                if(fullOption){
                    this.$emit('event', 'resetChecks', null, optionModal);
                } 
                return false;
            }
           
            switch(optionModal){
                case 'sendType':
                    switch(id){
                        case 'delivery': //guarda la direccion del usuario como value al darle al checkbox
                            checkSchedule = true;
                            break;
                        case 'pickup':
                            if(value==null || value == ''){ // hace reset del selector a la primera tienda del sistema actual (no saltar a otro menu solo por marcar la opcion)
                                if(this.storesAvailables){
                                    checkSchedule = true;
                                    value = Object.keys(this.storesAvailables).find(s => !this.isOtherSystemStore(s)) || '';
                                    break;
                                }
                            }else if(this.isOtherSystemStore(value)){ //tienda de otro sistema: el cambio (y el aviso de carrito) lo resuelve App; no se selecciona aqui
                                this.$emit('event', 'switchPickupStore', value);
                                return false;
                            }
                            checkSchedule = true;
                            break;
                    }
                    break;
                case 'schedule':
                    switch(id){
                        case 'now':

                            if(this.cartOrderSelection.sendType.selected == 'delivery'){
                                if(this.user.data.homes.hasOwnProperty(this.cartOrderSelection.sendType.value)){
                                    if(this.listStoreStatus.hasOwnProperty(this.user.data.homes[this.cartOrderSelection.sendType.value].storeNumber)){
                                        if(this.listStoreStatus[this.user.data.homes[this.cartOrderSelection.sendType.value].storeNumber].status == 'open'){
                                            value = (new Date).toLocaleString("en-CA", { hour12: false, day: '2-digit', month: '2-digit', year: 'numeric', hour:'2-digit', minute:'2-digit', second:'2-digit' });
                                            break;
                                        }
                                    }
                                }
                                this.cartOrderTransition.schedule.options[0].enabled = false; // esto en caso de no estar abierta la tienda
                                this.cartOrderTransition.schedule.options[0].show = false;

                            }else if(this.cartOrderSelection.sendType.selected == 'pickup'){
                                if(this.listStoreStatus.hasOwnProperty(this.cartOrderSelection.sendType.value)){
                                    if(this.listStoreStatus[this.cartOrderSelection.sendType.value].status == 'open' || this.listStoreStatus[this.cartOrderSelection.sendType.value].status == 'close'){
                                        value = (new Date).toLocaleString("en-CA", { hour12: false, day: '2-digit', month: '2-digit', year: 'numeric', hour:'2-digit', minute:'2-digit', second:'2-digit' });
                                        break;
                                    }
                                }
                            }else{
                                return false
                            }

                            this.$emit('event', 'resetChecks', null, optionModal);

                            break;
                        case 'await':
                            if(value==null || value == ''){
                                value = {date:"", hour:""}
                            }else if(typeof this.cartOrderSelection[this.cartOrderSelection.modalPosition].value === 'object' ){
                                let nextValue = value;
                                value = this.cartOrderSelection[this.cartOrderSelection.modalPosition].value;
                                value[key] = nextValue;

                                if(key == 'date'){ //validar si es cambio de fecha, para poner la hora del primer indice y evitar horas no validas
                                    value.hour = Object.keys(this.getAvailableHours(nextValue))[0];
                                }
                            }
                            break;
                    }
                    break;
                case 'payForm':
                    switch(id){
                        case 'cash':
                            break;
                    }
                    break;
                case 'cashMode':
                    value = this.numericsData(value);
                    break;
                default:
                    break;
            }

            this.$emit('event', 'selectOption', id, optionModal, value); // asigna a la opcion su valor seleccionado (padre carrito/orders)

            if(checkSchedule){
                
                this.cartOrderTransition.schedule.options[0].enabled = this.isOpenUserStore();
                this.cartOrderTransition.schedule.options[0].show = this.isOpenUserStore();

                if(!this.isOpenUserStore()){ //si no esta abierta la sucursal seleccionar el check de programar del siguiente pas
                    this.selectOption(null, 'await', 'schedule', '', '', false)
                }else{
                    this.$emit('event', 'resetChecks', null, 'schedule');
                }
            }
        },

        returnToCarLater(dir=''){
            this.$emit('event', 'editDirections', dir);
        },

        isOpenUserStore(){
            let storeId = 0;
            switch(this.cartOrderSelection.sendType.selected){
                case 'delivery': //nombre de direccion del usuario en value
                    storeId = this.user.data.homes.hasOwnProperty(this.cartOrderSelection.sendType.value) ? this.user.data.homes[this.cartOrderSelection.sendType.value].storeNumber : 0;
                    break;
                case 'pickup': //id de la tienda en value
                    storeId = this.cartOrderSelection.sendType.value;
                    break;
            }
            if(this.listStoreStatus){
                if(this.listStoreStatus.hasOwnProperty(storeId)){
                    if(this.listStoreStatus[storeId].status == 'open'){
                        return true
                    }
                }
            }
            return false
        },

    },
    data(){
        return{
            storesAvailables:{},
            pickupStoreCity:{}, //storeNumber -> entrada de ciudad (sistema) a la que pertenece
            transition:false,
            pending:false,
            phrases:{
                f1:{
                    es:'EDITAR',
                    en:'EDIT'
                },
                f2:{
                    es:'Continuar',
                    en:'Continue'
                },
                f3:{
                    es:'Realizar Pedido',
                    en:'Send Order'
                },
                f4:{
                    es:'Tiempo Estimado',
                    en:'Estimated Time'
                },
                f5:{
                    es:'Llegada estimada',
                    en:'Estimated arrival'
                },
                f6:{
                    es:'Al finalizar la orden comenzaremos a preparar tu pedido.',
                    en:'Upon completion of the order we will begin prepare your order.'
                },
                f7:{
                    es:'Selecciona el día y hora para recibir tu pedido. El tiempo final podria variar.',
                    en:'Select the day and time to receive your order. Final time may vary.'
                },
                f8:{
                    es:'Insertar valor si requiere cambio.',
                    en:'Insert value if coin change is required.'
                },
                f9:{
                    es:'envío',
                    en:'delivery'
                },
                f10:{
                    es:'recolección',
                    en:'pickup'
                },
                f11:{
                    es:'Seleccionar Surcursal',
                    en:'Choose Store'
                },
                f12:{
                    es:'Dia',
                    en:'Day'
                },
                f13:{
                    es:'Hora',
                    en:'Hour'
                },
                f14:{
                    es:'Hoy',
                    en:'Today'
                },
                f15:{
                    es:'Mañana',
                    en:'Tomorrow'
                },
                f16:{
                    es:'Pasado mañana',
                    en:'Day after tomorrow'
                },
                f17:{
                    es:'500',
                    en:'500'
                },
                f18:{
                    es:'Ir a mi cuenta',
                    en:'Go to my account'
                },
                f19:{
                    es:'Agregar Dirección',
                    en:'Add Address'
                },
                f20:{
                    es:'Tu dirección no tiene cobertura para reparto; Cámbiala o selecciona la opción "Recoger en sucursal".',
                    en:'Your address does not have coverage for delivery, change it or choose the option Store pickup.'
                },
                f21:{
                    es:'Ingresar dirección válida',
                    en:'Set a valid address'
                },
                f22:{
                    es:'Falta agregar una dirección de envio, edítala en tu cuenta o selecciona la opción "Recoger en sucursal".',
                    en:'You do not have an address for delivery. Please add one or choose the Store Pickup option.'
                },
                f23:{
                    es:'Sin Dirección',
                    en:'Empty Address'
                },
                f24:{
                    es:'Sin Servicio',
                    en:'No Service'
                },
                f25:{
                    es:'Elige una de nuestras sucursales para pasar a recoger tu pedido.',
                    en:'Choose one of our stores to pick up your order.'
                },
                f26:{
                    es:'Por el momento nuesta sucursal se encuentra fuera de horario de servicio, pero puedes programar tu pedido para un horario futuro.',
                    en:'Currently, our store is out of service hours, But you could schedule your order for a future time'
                },
                f27:{
                    es:'Por el momento nuesta sucursal se encuentra desconectada, pero te recomendamos llamar a nuestro callcenter para realizar tu pedido',
                    en:'Currently, our store is offline, but we recommend calling our call center to place your order.'
                },
                f28:{
                    es:'Aceptar',
                    en:'Accept'
                },
                f29:{
                    es:'Nuestra sucursal aún no abre',
                    en:'Our store is not open yet'
                },
                f30:{
                    es:'Sucursal fuera de línea',
                    en:'Offline store'
                },
                f31:{
                    es:'Trae Cambio de',
                    en:'Bring money change for'
                },
                f32:{
                    es:'Falta agregar una dirección válida para la región de la tienda o selecciona la opción "Recoger en sucursal".',
                    en:'You do not have an address for delivery for the city region. Please add one or choose the Store Pickup option.'
                },
                f33:{
                    es:'Tiempo personalizado',
                    en:'Customized Time'
                },
                f34:{
                    es:'Para proteger tu privacidad, solo mostramos la colonia de tu dirección de envio.<br><br class="d-none d-sm-block">Si necesitas ver la dirección completa, verifica tu identidad con un código de WhatsApp.',
                    en:'To protect your privacy, we only show your district. If you need to see the full address, please verify your identity with a WhatsApp code.'
                },
                f35:{
                    es:'VERIFICAR Y EDITAR',
                    en:'VERIFY AND EDIT'
                },
                f36:{
                    es:'Tarjeta crédito/débito',
                    en:'Credit/Debit Card'
                },
                f37:{
                    es:'Artículos',
                    en:'Articles'
                },
            },

            /* assets */
            a15:require('@/assets/images/a15.svg'),
            a11:require('@/assets/images/a11.svg'),
            a10:require('@/assets/images/a10.svg'),
            a48:require('@/assets/images/a48.svg'),
            a49:require('@/assets/images/a49.svg'),

            /* conf interna */
            openDirSelector:false,
            cartOrderTransition:{
                
                sendType:{
                    title:{
                        es:'Elige tu forma de envío',
                        en:'Choose your shipping method'
                    },
                    defValue:null, 
                    options:[
                        {
                            simbol:require('@/assets/images/a27.svg'),
                            icon:require('@/assets/images/a11.svg'),
                            show:true,
                            allow:this.allowDelivery(), // esto se podria cambiar watch listStoreStatus -> status de tiendas y en watch de objeto usuario
                            enabled:true,
                            description:{
                                es:'Envío a domicilio',
                                en:'Home delivery'
                            },
                            idOption:'delivery',
                        },
                        {
                            simbol:require('@/assets/images/a27.svg'),
                            icon:require('@/assets/images/a15.svg'),
                            show:true,
                            allow:2,
                            enabled:true, // esto se podria cambiar en la funcion listOnline cuando se actualizan los status de tiendas
                            description:{
                                es:'Recoger en sucursal',
                                en:'Store pickup'
                            },
                            idOption:'pickup',
                        }
                    ]
                },
                schedule:{
                    title:{
                        es:'Horario de envío',
                        en:'Shipping schedule'
                    },
                    defValue:null,
                    options:[
                        {
                            simbol:require('@/assets/images/a27.svg'),
                            icon:require('@/assets/images/a17.svg'),
                            show:this.isOpenUserStore(),
                            allow:2,
                            enabled:this.isOpenUserStore(),
                            description:{
                                es:'Preparar ahora mismo',
                                en:'Prepare right now'
                            },
                            idOption:'now'
                        },
                        {
                            simbol:require('@/assets/images/a27.svg'),
                            icon:require('@/assets/images/a16.svg'),
                            show:true,
                            allow:2,
                            enabled:true,
                            description:{
                                es:'Programar',
                                en:'Schedule'
                            },
                            idOption:'await',
                        }
                    ],
                },
                payForm:{
                    title:{
                        es:'Forma de pago',
                        en:'method of payment'
                    },
                    defValue:0,
                    options:[
                        {
                            simbol:require('@/assets/images/a27.svg'),
                            icon:require('@/assets/images/a29.svg'),
                            show:true,
                            allow:2,
                            enabled:true,
                            description:{
                                es:'Pago en efectivo',
                                en:'Cash payment'
                            },
                            idOption:'cash',
                        },
                        {
                            simbol:require('@/assets/images/a27.svg'),
                            icon:require('@/assets/images/a30.svg'),
                            show:true,
                            allow:2,
                            enabled:true,
                            description:{
                                es:'Enviar terminal bancaria',
                                en:'Send bank terminal'
                            },
                            idOption:'card',
                        },
                        {
                            simbol:require('@/assets/images/a27.svg'),
                            icon:require('@/assets/images/a28.svg'),
                            show:this.allowOnlineMode(),
                            allow:2,
                            enabled:this.allowOnlineMode(),
                            description:{
                                es:'Pagar con paypal',
                                en:'Pay with paypal'
                            },
                            idOption:'paypal',
                        }
                    ]
                },
                cashMode:{
                    title:{
                        es:'Cambio de pago',
                        en:'change of payment'
                    },
                    defValue:0,
                    options:[
                        {
                            simbol:require('@/assets/images/a27.svg'),
                            icon:require('@/assets/images/a29.svg'),
                            show:true,
                            allow:6,
                            enabled:true,
                            description:{
                                es:'Pago en efectivo',
                                en:'Cash payment'
                            },
                            idOption:'cash',
                        }
                    ]
                },
                onlineMode:{
                    title:{
                        es:'Pago en línea',
                        en:'Pay online'
                    },
                    defValue:0,
                    options:[{
                            simbol:require('@/assets/images/a27.svg'),
                            icon:require('@/assets/images/a28.svg'),
                            show:true,
                            allow:6,
                            enabled:true,
                            description:{
                                es:'Pagar con paypal',
                                en:'Pay with paypal'
                            },
                            idOption:'default',
                        }]
                },
                storeClosed:{
                    title:{
                        es:'Sucursal Cerrada',
                        en:'Store Closed'
                    },
                    defValue:0,
                    options:[]
                },
                storeError:{
                    title:{
                        es:'Sucursal Desconectada',
                        en:'Store Disconected'
                    },
                    defValue:0,
                    options:[]
                }
            },
        }
    }
}
</script>
<style lang="css" scoped>
    .colonyText{
        font-size: 20px;
        color:var(--text13)
    }
    .cpText{
        color:var(--text17)
    }
    .dirComplete{
        font-size: 18px;
        color:var(--text17)
    }
    .descriptionText{
        font-size: 18px;
        color:var(--text17)
    }
    .editButton{
        font-size: 14px;
        color: var(--text7);
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;   
        user-select: none;
    }
    .hiddenInfoLabel{
        font-size: 14px;
        color: var(--text17);
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;   
        user-select: none;
    }
    .titleOption{
        font-size: 24px;
        flex-shrink: 0;
    }
    .titleOptionError{
        font-size: 28px;
        flex-shrink: 0;
    }
    .subtitled{
        font-size: 18px;
        color: var(--text24);
    }
    .callcenterText{
        font-size: 22px;
        flex-shrink: 0;
        color: var(--text9);
    }
    .checkBoxArea{
        padding-top: 19px;
        height: 100%;
        flex-shrink: 0;
    }
    .option:hover .checkBoxArea .commonPageCheckbox input:not(:checked) + label{
        border: 3px solid var(--secondary);
    }
    .checkBoxArea .commonPageCheckbox label{
        width: 30px;
        height: 30px;
        border-radius: 6px;
        overflow: visible;
    }
    .checkBoxArea .commonPageCheckbox img{
        width: 100%;
        height: 100%;
        transform: scaleX(2) scaleY(2) translateY(-10%);
    }
    .commonPageCheckbox span{
        background-color: transparent;
    }
    /*.icon{
        padding-top: 12px;
        width: 70px;
        height: 100%;
        flex-shrink: 0;
    }*/
    .option[enabled='false']{
        pointer-events: none;
        opacity: 0.25 !important;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;   
        user-select: none;
    }
    .option{
        cursor: pointer;
    }
    .option.notSelected:hover .dataArea{
        opacity: 0.95 !important;
    }
    .option.notSelected {
        opacity: 0.75;
        display: none !important;
    }
    #orderSteps{
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 4000;
        position: fixed;
        top:0;
        left:0;
    }
    .rel{
        position: relative;
        width: 100%;
        height: 100%;
    }
    .floatRectangle{
        width: 750px;
        max-width: 96%;
        height: auto;
        overflow-y:visible;
        overflow-x: visible;
        max-height:85vh;
        position: absolute;
        align-content: center;
        align-items:center;
        animation:bounce 0.2s linear 1 forwards; 
    }
    
    .floatRectangle > .rel{
        background-color: #fff;
        overflow-y:visible;
        overflow-x: visible;
    }
    @media (max-width: 768px) {  
        .floatRectangle > .rel{
            overflow-y:auto
        }
        .floatRectangle{
            height: 100vh;
            max-width: 100%;
            max-height:100vh;
        }
    }
    .floatRectangle > .rel.in{
        animation:indoor 0.3s linear 1 forwards;
    }
    .floatRectangle > .rel.out{
        animation:outdoor 0.3s linear 1 forwards;
    }
    .floatRectangle .headerModal{
        background-color: var(--primary)

    }
    .titleSelect{
        line-height: 1.2;
        padding-top: 5px;
        color:var(--text2);
        word-wrap: break-word;
        word-break: break-word;
        z-index: 2;
    }
    .closeButton{
        position: absolute;
        right: 0;
        margin: auto;
        color:var(--text10);
        z-index: 5;
        border-left: 2px solid var(--vigequinary);
    }
    .closeButton:hover svg{
        transform: scale(1.2);
        filter: contrast(0.9)
    }
    .closeButton svg{
        pointer-events: none;
        height: 25px;
    }

    ::v-deep(.closeButton svg path){
        fill: #fff;
    }

    ::v-deep(.posIcon){
        width:60px;
        height: 60px
    }

    .storeOption input[type="radio"] {
        display: none;
      }
      
      .storeOption label {
        font-size: 20px;
        cursor: pointer;
        display: flex;
        align-items: center;
        align-content: center
      }
      
      .storeOption input[type="radio"] + label .circle {
        content: '';
        position: relative;
        width: 22px; /* ajusta el tamaño del botón del radio */
        height: 22px; /* ajusta el tamaño del botón del radio */
        border: 1px solid #999;
        border-radius: 50%;
        display: inline-flex;
        background-color: #fff;
        align-items: center;
        align-content: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 0
      }
      
      .storeOption input[type="radio"]:checked + label .circle::after {
        content:"";
        display: block;
        border-radius: 50%;
        width: 12px; /* ajusta el tamaño del botón del radio */
        height: 12px; /* ajusta el tamaño del botón del radio */
        background-color: var(--primary); /* cambia el color del botón del radio cuando está seleccionado */
      }

    .timeLabel{
        color:var(--text11);
        line-height: 1.2;
        font-size: 60px;
    }

    .subTimeLabel{
        color:var(--text11);
        font-size: 14px;
    }

    .timeIndicator{
        flex-shrink: 0;
    }

    .dataArea{
        width: calc(100% - 30px);
    }

    .buttonNext{
        font-size:20px !important;
        min-height: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
        align-content: center;
    }

    .borderedBottom{
        border-bottom: 1px solid var(--nonagenary);
    }
    
    .articlePrice{
        white-space: nowrap;
    }

    .articleName{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-transform: capitalize;
        font-size: 18px;
    }

    .titleArticles{
        font-size: 20px;
        color: var(--text6);
    }

    .titleArticles2{
        font-size: 20px;
    }

    .promo{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-transform: capitalize;
        font-size: 16px;
    }

    .divisor{
        width: 100%; 
        border-bottom: solid 2px #999
    }

    .icon-select {
        width: 50px;
        position: absolute;
        left: 75px;
        top:67px;
        height: 50px;
        vertical-align: -0.15em;
        overflow: hidden;
        transition: transform 0.3s ease;
        -ms-overflow-style: none;
        -webkit-user-select: none; 
        -moz-user-select: none; 
        -ms-user-select: none; 
        user-select: none; 
        transform: rotate(180deg);
    }

    @media (max-width: 768px) {  
        .icon-select{
            left: 20px !important;
        }
    }

    .icon-select path{
        stroke-width: 100px;
        fill: var(--ondecagenary);
    }

    .icon-select.opened{
        transform: rotate(0deg);
    }

</style>